module.exports = __webpack_public_path__ + "static/media/M113ws.84d3a38a.pdf";